import(/* webpackMode: "eager" */ "/app/src/app/pricing/page.jsx");
